import Immutable from "immutable";

export class FireableBusinessEvent extends Immutable.Record({
  value: "",
  eventKey: "",
  isVariable: false,
}) {}
